import React from 'react';

const NotFoundPage: React.FC = () => {
  return (
    <div style={{ textAlign: 'center', marginTop: '200px' , marginBottom: '200px'}}>
      <h1>404 Not Found</h1>
      <p>Aradığınız sayfa bulunamadı.</p>
    </div>
  );
};

export default NotFoundPage;